module.exports = __webpack_public_path__ + "packs/media/images/jungleboards/board-d261e89b9ff755ebdd5ea70620e5b707.jpg";